import axios from "../../../apis/Api";
import history, { logout } from "../../../history";
import { toast } from "react-toastify";

export const handleScrV2RequestError = (error) => {
  if (axios.isCancel?.(error) || error?.code === "ERR_CANCELED") {
    return;
  }

  if (error.response) {
    if (error.response.status === 401) {
      logout();
      history.push("/login");
      history.go("/login");
      return;
    }

    if (error.response.data) {
      toast.error(
        error.response.data.Message
          ? error.response.data.Message
          : error.response.data.message
      );
      return;
    }
  }

  toast.error("Error while processing the request");
};

export const extractScrV2ApiResponse = (data) => {
  if (!data || typeof data !== "object") {
    return null;
  }

  if (data.response !== undefined && data.response !== null) {
    return data.response;
  }

  if (data.Response !== undefined && data.Response !== null) {
    return data.Response;
  }

  if (data.scrId || data.SCRId) {
    return data;
  }

  return null;
};

export const pickScrV2Value = (source, camelKey, pascalKey, fallback = undefined) => {
  if (!source || typeof source !== "object") {
    return fallback;
  }

  if (source[camelKey] !== undefined && source[camelKey] !== null) {
    return source[camelKey];
  }

  if (source[pascalKey] !== undefined && source[pascalKey] !== null) {
    return source[pascalKey];
  }

  return fallback;
};
